export function normalizeMaterialFoodSearch(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

export function filterMaterialFoodsByName<T extends { name: string }>(
  foods: T[],
  search: string,
): T[] {
  const query = normalizeMaterialFoodSearch(search);
  if (!query) return foods;
  return foods.filter((food) => normalizeMaterialFoodSearch(food.name).includes(query));
}
